const translation = {
  title: 'Market',
  filters: {
    all: 'All',
  },
  server: {
    available: 'Available',
    notFound: 'No servers found matching your criteria',
  },
  resourceSelector: {
    title: 'Resource Filter',
    billingMode: 'Billing Mode',
  }
}

export default translation